import React, { useContext, useEffect } from 'react';
import useOnChange from '../../../../hooks/useChange'
import Item from './Item';
import { ContextBuilder } from "../../../../context/builder/reducers";
import arrayMove from 'array-move';
import SortableList, { INDUSTRIAL_PLATFORM_ITEM } from '../SortableList';

const ItemList = (props) => {
    const { state, dispatch } = useContext(ContextBuilder);
    const onChange = useOnChange(props.index);
    useEffect(() => {
        if (!props.content) {
            const data = state.data;
            data.value[props.index].content = {
                title: '',
                elements: []
            }
            dispatch({ type: 'data', payload: { data } })
        }
    });

    let elements = props.content.elements || [];

    const onSortEnd = ({ oldIndex, newIndex }) => {
        const data = state.data;
        elements = arrayMove(elements, oldIndex, newIndex);
        data.value[props.index].content.elements = elements;
        dispatch({ type: 'data', payload: { data: data } });
    };

    const addItem = () => {
        const data = state.data;
        elements = [...elements, { subTitle: '', img: '', title: '', description: '' }];
        data.value[props.index].content.elements = elements;
        dispatch({ type: 'data', payload: { data: data } });
    };

    const deleteButtonHandler = (e) => {
        const index = e.currentTarget.getAttribute('index');
        const data = state.data;
        elements.splice(index, 1);
        data.value[props.index].content.elements = elements;
        dispatch({ type: 'data', payload: { data: data } });
    };

    return (
        <SortableList
            item={INDUSTRIAL_PLATFORM_ITEM}
            titleComponent="Производственная площадка"
            title={props.content.title || ''}
            type={props.type}
            elements={elements}
            onChange={onChange}
            onSortEnd={onSortEnd}
            axis="xy"
            useDragHandle
            addItem={addItem}
            deleteButtonHandler={deleteButtonHandler}
        />);
}

export default ItemList;
